import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import LeftToolbar from "./LeftToolbar";
import CenterControls from "./CenterControls";
import RightSpeedControl from "./RightSpeedControl";

const PlaybackControlBar = ({
  isPlaying,
  onTogglePlay,
  muted,
  onToggleMuted,
  timeScale,
  onSelectTimeScale,
  playbackTime,
  eventDates,
  onApplyTime,
  onCalendarMonthChange,
  onShiftPlayback,
  playbackSpeed,
  onCycleSpeed,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        minHeight: 34,
      }}
    >
      <LeftToolbar
        isPlaying={isPlaying}
        onTogglePlay={onTogglePlay}
        muted={muted}
        onToggleMuted={onToggleMuted}
        timeScale={timeScale}
        onSelectTimeScale={onSelectTimeScale}
      />
      <CenterControls
        playbackTime={playbackTime}
        eventDates={eventDates}
        onApplyTime={onApplyTime}
        onCalendarMonthChange={onCalendarMonthChange}
        onShiftPlayback={onShiftPlayback}
      />
      <RightSpeedControl
        playbackSpeed={playbackSpeed}
        onCycleSpeed={onCycleSpeed}
      />
    </Box>
  );
};

PlaybackControlBar.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  onTogglePlay: PropTypes.func.isRequired,
  muted: PropTypes.bool.isRequired,
  onToggleMuted: PropTypes.func.isRequired,
  timeScale: PropTypes.string.isRequired,
  onSelectTimeScale: PropTypes.func.isRequired,
  playbackTime: PropTypes.number.isRequired,
  eventDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  onApplyTime: PropTypes.func.isRequired,
  onCalendarMonthChange: PropTypes.func.isRequired,
  onShiftPlayback: PropTypes.func.isRequired,
  playbackSpeed: PropTypes.string.isRequired,
  onCycleSpeed: PropTypes.func.isRequired,
};

export default PlaybackControlBar;
